<template>
    <medium-dialog
        @ok="importQuestion"
        v-model="dialog"
        title="Import pertanyaan"
        loading="importquestion"
        scrollable
        persistent
        :noActivator="noActivator"
    >
        <template v-if="! noActivator" #activator="{ on }">
            <v-btn v-on="on" color="primary" small>
                <v-icon left>mdi-plus</v-icon>
                import
            </v-btn>
        </template>

        <template #beforeAction>
            <selected-question-info :selectedQuestions="selectedQuestions"></selected-question-info>
        </template>

        <slot name="information"></slot>

        <v-autocomplete
            @change="questionBankSelected"
            v-model="selectedQuestionBank"
            label="Bank Soal"
            :items="questionBanks"
            :disabled="!! selectedQuestionBank && selectedQuestions.length != 0"
        ></v-autocomplete>

        <import-question-table
            v-model="selectedQuestions"
            :questions="questions"
            ref="table"
        ></import-question-table>
    </medium-dialog>
</template>

<script>
import MediumDialog from '@/components/dialog/MediumDialog'
import ImportQuestionTable from './ImportQuestionTable.vue'
import SelectedQuestionInfo from './SelectedQuestionInfo.vue'

export default {
    props: {
        noActivator: {
            type: Boolean,
            default: false
        }
    },

    components: {
        MediumDialog,
        ImportQuestionTable,
        SelectedQuestionInfo,
    },

    data: () => ({
        dialog: false,
        selectedQuestionBank: null,
        questionBanks: null,
        questions: null,
        selectedQuestions: [],
    }),

    watch: {
        dialog() {
            if (! this.dialog) {
                this.$refs.table.resetSelectedQuestions()
            }
        }
    },

    methods: {
        async questionBankSelected() {
            const response = await this.$apiv2.get(`question-import/question-bank/${this.selectedQuestionBank}/question`, { loader: 'importquestion' })

            this.questions = response.data.questions
        },

        importQuestion() {
            this.$emit('import', this.selectedQuestions)
            this.dialog = false
        },

        show() {
            this.dialog = true
        }
    },

    async created() {
        const response = await this.$api.get('questionbank', { loader: 'importquestion' })
        this.questionBanks = response.data.questionbanks.map(questionbank => ({
            value: questionbank.id,
            text: questionbank.title
        }))
        this.questionBanks.reverse()
    }
}
</script>
